import { render, staticRenderFns } from "./TareaContentComponent.vue?vue&type=template&id=95970922&"
import script from "./TareaContentComponent.vue?vue&type=script&lang=js&"
export * from "./TareaContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports